import { db, auth } from "@/plugins/firebase";
import firebase from 'firebase/app';
import 'firebase/app';
import 'firebase/auth'
import { bus } from '@/main'

export async function getContent({ commit }, { type, collection, mutation }) {
    var dataArr = []
    commit(mutation, dataArr)

        await db.collection(collection).where("type", "==", type).where("state", "!=", "deleted").get().then(async function (docs) {
            if (docs.empty) {
                return
            }

            for (var i = 0; i < docs.size; i += 1) {
                var doc = docs.docs[i];
                dataArr.push(doc.data());
            }

            commit(mutation, dataArr)
        })

}

export async function getContentByRegion({ commit }, { type, collection, mutation, region }) {
    var dataArr = []
    commit(mutation, dataArr)

        await db.collection(collection).where("type", "==", type).where("data.region.id", "==", region.id).where("state", "!=", "deleted").get().then(async function (docs) {
            if (docs.empty) {
                return
            }

            for (var i = 0; i < docs.size; i += 1) {
                var doc = docs.docs[i];
                dataArr.push(doc.data());
            }

            commit(mutation, dataArr)
        })

}

export async function createNewContent({ commit }, { details, collection, type }) {
    return new Promise((resolve, reject) => {
        const ref = db.collection(collection).doc()

        const refObject = {
            id: ref.id,
            ...details,
            createdBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        }

        ref.set(refObject).then(() => {
            console.log("Created new Content")
            bus.$emit("show-snackbar", { text: "New " + type + " Created!", color: "success" });
            resolve()
        }).catch((err) => {
            bus.$emit("show-snackbar", { text: err, color: "error" });
            reject()
        })
    })

}



export async function updateContent({ commit }, { details, collection, type }) {
    return new Promise((resolve, reject) => {
        console.log("updating pin: ", details)
        if (details.state === 'scheduled') {
            details.state = 'scheduled'
        }

        if (details.state === 'active' || details.state === 'expired') {
            details.state = 'updated'
        }

        const refObj = {
            ...details,
            updatedBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }

        db.collection(collection).doc(details.id).set(
            refObj, { merge: true }).then(() => {
                bus.$emit("show-snackbar", { text: type + " updated!", color: "success" });
                resolve()
            }).catch((err) => {
                bus.$emit("show-snackbar", { text: err, color: "error" });
                reject()
            })
    })
}

export async function deleteContent({ commit }, { details, collection, type }) {
    return new Promise((resolve, reject) => {
        console.log("updating pin: ", details)

        const refObj = {
            ...details,
            deletedBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }

        db.collection(collection).doc(details.id).set(
            refObj, { merge: true }).then(() => {
                bus.$emit("show-snackbar", { text: type + " Successfully Deleted!", color: "success" });
                resolve()
            }).catch((err) => {
                bus.$emit("show-snackbar", { text: err, color: "error" });
                reject()
            })
    })

}
